export const categoryNameSeparator = ">";
export const categoryIdSeparator = "|";
export enum monthCapacityStatusEnum {
  /** 待提报 */
  pending = 0,
  /** 已驳回 */
  rejected = 2,
}
